import { CircularDependencyFreeStore } from '../CircularDependencyFreeStore'
import ProjectStore from './store'

const projectStore = new ProjectStore()

CircularDependencyFreeStore.projectStore = projectStore

export { projectStore as projectStore }
